/** Dataset name for member record vector search (matches backend MEDS_DATASET_VERSION). */
export const RECORDS_MEDS_VECTOR_DATASET = 'records_meds';

/** Decision harness dataset id for MRR / records_review. */
export const MRR_DECISION_DATASET = 'mrr_v1';

/** Decision harness dataset for clinical tag evaluations. */
export const CLINICAL_TAGS_DATASET = 'clinical_tags_v1';

/** @deprecated Prefer CLINICAL_TAGS_DATASET */
export const MRR_CRITERIA_DATASET = CLINICAL_TAGS_DATASET;

export const CLINICAL_TAG_MODES = [
  { value: 'yes_no', label: 'Yes / No' },
  { value: 'multilabel', label: 'Multilabel' },
  { value: 'screen', label: 'Screen' },
];

export const CLINICAL_TAG_YES_POLARITIES = [
  { value: 'concern', label: 'Yes = concern' },
  { value: 'clear', label: 'Yes = clear' },
];

export const CLINICAL_TAG_ANSWERS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

/** Valid per-tag review_state GT values (Correct/Affirm drawer). */
export const CLINICAL_TAG_REVIEW_STATES = [
  { value: 'needs_review', label: 'Needs review' },
  { value: 'needs_more_info', label: 'Needs more info' },
];

/**
 * Pipeline matrix sidebar filters: real review states plus row-level
 * derived flags (complete / passed) that are not writable GT values.
 */
export const CLINICAL_TAG_MATRIX_REVIEW_FILTERS = [
  ...CLINICAL_TAG_REVIEW_STATES,
  { value: 'complete', label: 'Complete' },
  { value: 'passed', label: 'Passed' },
];

export const CLINICAL_TAG_SOURCES = [
  { value: 'agent', label: 'Agent' },
  { value: 'manual', label: 'Manual' },
];

/** @deprecated Prefer CLINICAL_TAG_ANSWERS + CLINICAL_TAG_REVIEW_STATES */
export const MRR_CRITERION_LABELS = [
  ...CLINICAL_TAG_ANSWERS,
  ...CLINICAL_TAG_REVIEW_STATES,
];

export const chipColorForTag = (answer, reviewState, yesPolarity = 'concern') => {
  const review = (reviewState || '').toLowerCase();
  if (review === 'needs_review' || review === 'needs_more_info') {
    return 'warning';
  }
  const normalized = (answer || '').toLowerCase();
  const yesIsClear = (yesPolarity || '').toLowerCase() === 'clear';
  if (normalized === 'yes') return yesIsClear ? 'success' : 'error';
  if (normalized === 'no') return yesIsClear ? 'error' : 'success';
  return 'default';
};

export const yesPolarityForMember = (definition, memberCohort) => {
  if (definition?.mode === 'multilabel') return null;
  const configs = definition?.cohort_configs || [];
  const cohort = String(memberCohort || '').trim();
  if (configs.length && cohort) {
    const match = configs.find((entry) => entry.cohort === cohort);
    if (match?.yes_polarity) return match.yes_polarity;
  }
  return definition?.yes_polarity || 'concern';
};

export const cohortConfigChipLabel = (entry, mode) => {
  if (mode === 'multilabel') return entry.cohort;
  const polarity = entry.yes_polarity === 'clear' ? 'yes=clear' : 'yes=concern';
  return `${entry.cohort} · ${polarity}`;
};

/** Cohorts table: tag name first; optional yes/no polarity suffix. */
export const cohortDefinitionChipLabel = (definition, config) => {
  const name = definition?.name || 'Clinical tag';
  if (definition?.mode === 'multilabel') return name;
  const polarity = config?.yes_polarity || definition?.yes_polarity;
  if (!polarity) return name;
  const suffix = polarity === 'clear' ? 'yes=clear' : 'yes=concern';
  return `${name} · ${suffix}`;
};

export const tagModeCaption = (definition) => {
  if (definition?.mode === 'multilabel') {
    const n = (definition.allowed_values || []).length;
    return n ? `multilabel · ${n}` : 'multilabel';
  }
  return 'yes / no';
};

export const isRecordsReviewPrefix = (prefix = '') => (
  prefix.includes('summaries/records_review/')
);

export const recordsReviewUserIdFromPrefix = (prefix = '') => {
  const match = prefix.match(/summaries\/records_review\/(\d+)(?:\/|$)/);
  return match ? Number(match[1]) : null;
};

export const isRecordsReviewPsv = (file) => {
  if (!file?.key) return false;
  return /summaries\/records_review\/\d+\/review\.psv$/i.test(file.key);
};
